import { checkCurrentMemory } from "../utils/localStorage"

const ENDPOINT = process.env.REACT_APP_ENDPOINT

const bugReport = async (message) => {
    let userCookies = checkCurrentMemory()
    try {
        const response = await fetch(`${ENDPOINT}/bug_report`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 
                "cookies": userCookies,
                "explanation": message
            })
        })
        const resp = await response.json();
        return resp;
    }
    catch (error) {
        console.error('Error checking match:', error);
    }
}

export default bugReport;